<div
  class="glass-card"
  [class]="'glass-card--' + tint + ' glass-card--padding-' + padding"
  [class.glass-card--interactive]="interactive"
>
  <ng-content></ng-content>
</div>
